// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../order-vue/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".submenu-header[data-v-6f5c0420]{width:100vw;background:#003c71;color:#fff;margin-left:-1rem;padding-left:1rem}.submenu-header .back-link[data-v-6f5c0420]{font-size:14px;color:#fff}", ""]);
// Exports
module.exports = exports;
